import { Component, OnInit } from '@angular/core';
import {AngularFireAuth} from '@angular/fire/auth';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {AngularFireDatabase} from '@angular/fire/database';
import {ActivatedRoute, Router} from '@angular/router';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.scss']
})
export class RegisterComponent implements OnInit {
  signUpForm: FormGroup;
  showError = false;
  email: string = "";
  user: any;
  errorMessage = "There was an error signing up. Please try again.";

  constructor(public auth: AngularFireAuth, private router: Router, formBuilder: FormBuilder, private db: AngularFireDatabase, route: ActivatedRoute) {
    route.queryParamMap.subscribe(params => {
      this.email = params.get('email');
    });
    this.signUpForm = formBuilder.group({
      firstName: [
        '',
        Validators.required,
      ],
      lastName: [
        '',
        Validators.required,
      ],
      email: [
        this.email,
        Validators.required,
      ],
      password: [
        '',
        Validators.required,
      ]
    });
  }

  ngOnInit() {
  }

  signUp() {
    if (this.signUpForm.valid) {
      this.auth.auth.createUserWithEmailAndPassword(this.signUpForm.controls.email.value, this.signUpForm.controls.password.value).then((res) => {
        this.user = res.user;
        res.user.updateProfile({
          displayName: this.signUpForm.controls.firstName.value + " " + this.signUpForm.controls.lastName.value,
        }).then((res) => {
          const itemRef = this.db.object(`users/${this.user.uid}`);
          itemRef.set({ email: this.user.email, uid: this.user.uid, username: this.user.displayName});
        }).then((r) => this.router.navigate(['live']));
      }).catch((err) => {
        if (err.code === "auth/email-already-in-use") {
          this.showError = true;
          this.errorMessage = err.message + " Maybe you've signed up before using our mobile app?";
        }
      });
    } else {
      this.showError = true;
      this.errorMessage = "Please complete all fields to sign up."
    }
  }

}
